import { Droplets, MapPin, ShieldCheck, BadgeCheck, Smartphone } from "lucide-react";
import { Reveal, SectionHead } from "../components/ui-bits";
import { WHY_CARZA } from "../config/defaults";

const ICONS = { droplets: Droplets, mapPin: MapPin, shield: ShieldCheck, badge: BadgeCheck, smartphone: Smartphone };

export default function WhyCarza() {
  return (
    <section id="why-carza" className="light-section relative pb-20 lg:pb-28" data-testid="why-carza-section">
      <div className="container-x">
        <SectionHead
          eyebrow="Why Carza?"
          light
          title={<>Car Care, Done the Smart Way.</>}
          sub="Five reasons Indian car owners choose CARZA over the neighbourhood wash."
        />
        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-6">
          {WHY_CARZA.map((c, i) => {
            const Icon = ICONS[c.icon] || BadgeCheck;
            const spans = ["lg:col-span-2", "lg:col-span-2", "lg:col-span-2", "lg:col-span-3", "lg:col-span-3"];
            return (
              <Reveal key={c.title} delay={i * 0.06} className={spans[i]}>
                <div className="card-light flex h-full items-start gap-4 rounded-3xl p-6" data-testid={`why-carza-card-${i}`}>
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-carza-dim text-carza">
                    <Icon size={20} />
                  </span>
                  <div>
                    <h3 className="font-display text-[17px] font-semibold text-nighttext">{c.title}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-[#5c5470]">{c.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
